//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      storesNumberList: [
        {
          name: '1-5家',
        },
        {
          name: '6-20家',
        },
        {
          name: '21-50家',
        },
        {
          name: '51家以上',
        },
      ],
      activeStoresNumberName: '',
    };
  },

  methods: {
    handleStoresNumberItemClick(item) {
      let { name } = item;
      let storesNumbe = this.activeStoresNumberName === name ? '' : name;
      this.activeStoresNumberName = storesNumbe;

      this.$store.commit('SET_USER_FIELD', {
        value: storesNumbe,
        key: 'storeNum',
      });

      setTimeout(() => {
        this.$router.push('/step03');
      }, 150);
    },
  },
};



// WEBPACK FOOTER //
// ./src/views/step/step02.vue